import React from 'react';

function Header() {
    return (
        <header>
            <h1>Welcome to Augmentis Labs (AugLabs)</h1>
            <nav>
                <a href="#hero">Home</a>
                <a href="#features">Features</a>
                <a href="#contact">Contact</a>
            </nav>
        </header>
    );
}

export default Header;